{
  "MusicPlayer_1": {
    "type": "TopLevelStyle",
    "styleType": "system",
    "compId": "",
    "componentClassName": "wixui.MusicPlayer",
    "pageId": "",
    "skin": "wixui.skins.MusicPlayer",
    "style": {
      "groups": {},
      "properties": {
        "regularColor": "color_15",
        "font": "font_8",
        "backgroundColor": "color_11",
        "borderSize": "0",
        "borderColor": "color_15",
        "borderRadius": "0",
        "hoverColor": "color_18"
      },
      "propertiesSource": {}
    },
    "id": "MusicPlayer_1",
    "metaData": {
      "isPreset": false,
      "schemaVersion": "1.0",
      "isHidden": false,
      "pageId": "masterPage"
    }
  }
}
